export default class IntercomAnalytics {
	constructor() {
		this.triggerElements = document.querySelectorAll('[data-intercom-trigger]');
		if (this.triggerElements.length === 0) {
			return;
		}

		this.initialized = false;
		this.maxWaitMs = 10000;
		this.pollIntervalMs = 500;

		this.initialize();
	}

	initialize() {
		if (this.initialized) {
			return;
		}

		if (window.Intercom) {
			this.attachKeydownListeners();
			this.initialized = true;
			return;
		}

		this.waitForIntercom();
	}

	waitForIntercom() {
		const start = Date.now();
		const check = () => {
			if (this.initialized) {
				return;
			}

			if (window.Intercom) {
				this.attachKeydownListeners();
				this.initialized = true;
				return;
			}

			if (Date.now() - start < this.maxWaitMs) {
				setTimeout(check, this.pollIntervalMs);
			}
		};

		setTimeout(check, this.pollIntervalMs);
	}

	attachKeydownListeners() {
		this.triggerElements.forEach((element) => {
			element.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					window.Intercom('showNewMessage');
				}
			});
		});
	}
}
